module.exports = __webpack_public_path__ + "static/media/vsp_premier_logo.0e80b410.png";